import React from 'react';
import { InputSwitchProps } from '@/components/Common/InputSwitch/InputSwitchProps';

export const InputSwitch = ({
  checked,
  onChange,
  register,
  name,
}: InputSwitchProps) => {
  return (
    <div className="flex justify-center">
      <label className="relative inline-block w-[50px] h-[24px]">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) =>
            onChange({ originalEvent: e, value: e.target.checked })
          }
          className="opacity-0 w-0 h-0"
          name={name}
          {...register}
        />
        <span
          className={`absolute cursor-pointer inset-0 rounded-full transition-all duration-300 ${checked ? 'bg-primary' : 'bg-warmRed'}`}
        >
          <span
            className={`absolute left-[3px] bottom-[3px] bg-grayishBlack h-[18px] w-[18px] rounded-full transition-all duration-300 ${
              checked ? 'transform translate-x-[26px]' : ''
            }`}
          />
        </span>
      </label>
    </div>
  );
};
